import React from 'react';
import { withTranslation } from 'react-i18next';
import './ProjectInfo.less';
import TitleValue from '../TitleValue/TitleValue';

class ProjectInfo extends React.Component {

	getDate = date => {
		const d = date ? new Date(date) : new Date();
		return `${this.pad(d.getDate())} - ${this.pad(d.getMonth() + 1)} - ${this.pad(d.getFullYear())}`; 
	}

	pad = num => {
		var size = 2;
		var s = num + '';
		while (s.length < size) s = '0' + s;
		return s;
	}

	render() {
		const { projectInfo, t, surveyInfo: {
			Modified, IsFilled
		} } = this.props;

		return (
			<div className="project-info">
				<div className="project-info__item">
					<TitleValue title={t('projectInfo_surveyDate')} value={IsFilled ? this.getDate(Modified) : this.getDate()} />
				</div>
				<div className="project-info__item">
					<TitleValue title={t('projectInfo_client')} value={projectInfo.client} />
				</div>
				<div className="project-info__item">
					<TitleValue title={t('projectInfo_projectName')} value={projectInfo.name} capitalize={false} />
				</div>
				<div className="project-info__item">
					<TitleValue title={t('projectInfo_customerProjectManager')} value={projectInfo.customerProjectManager} />
				</div>
				<div className="project-info__item">
					<TitleValue title={t('projectInfo_projectManager')} value={projectInfo.projectManager} />
				</div>
				<div className="project-info__item">
					<TitleValue title={t('projectInfo_projectTeamMembers')} value={projectInfo.members} />
				</div>
			</div>
		);
	}
}

export default withTranslation('translations')(ProjectInfo);
